var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasMarketingConsent)?_c('div',{attrs:{"data-ad-slot-type":_vm.type,"data-ad-unit-code":_vm.dataAdUnitCode}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }